// FAQ Management Class
class PremiumFAQ {
  constructor() {
    this.activeItems = new Set();
    this.init();
  }

  init() {
    this.buildNavigation();
    this.setupAccordion();
    this.setupScrollspy();
    this.setupFeedback();
    this.addKeyboardSupport();
  }

  buildNavigation() {
    const items = document.querySelectorAll('.faq-item');
    const desktopNav = document.getElementById('faqNav');
    const mobileNav = document.getElementById('mobileNav');
    
    if (!desktopNav || !mobileNav) return;
    
    items.forEach((item, index) => {
      const text = item.querySelector('.q-text').textContent;
      const shortText = text.length > 40 ? text.substring(0, 40) + '...' : text;
      const number = index + 1;
      
      // Desktop navigation
      const desktopLi = document.createElement('li');
      desktopLi.innerHTML = `
        <a href="#${item.id}" data-target="${item.id}">
          <span class="nav-icon"></span>
          ${shortText}
        </a>
      `;
      desktopNav.appendChild(desktopLi);
      
      // Mobile navigation
      const mobileLi = document.createElement('li');
      mobileLi.innerHTML = `
        <a href="#${item.id}" data-target="${item.id}">
          <span class="nav-icon"></span>
          ${number}
        </a>
      `;
      mobileNav.appendChild(mobileLi);
    });

    // Handle navigation clicks
    document.querySelectorAll('[data-target]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('data-target');
        const target = document.getElementById(targetId);
        
        if (target) {
          // Smooth scroll to target
          target.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
          
          // Open the FAQ item
          setTimeout(() => {
            if (!target.classList.contains('open')) {
              this.toggleFAQ(target.querySelector('.faq-question'));
            }
          }, 500);
        }
      });
    });
  }

  setupAccordion() {
    const questions = document.querySelectorAll('.faq-question');
    
    questions.forEach(question => {
      question.addEventListener('click', () => this.toggleFAQ(question));
    });
  }

  toggleFAQ(question) {
    const item = question.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    
    // Toggle current item
    item.classList.toggle('open');
    question.setAttribute('aria-expanded', !isOpen);
    
    // Update active items set
    if (!isOpen) {
      this.activeItems.add(item.id);
    } else {
      this.activeItems.delete(item.id);
    }
    
    // Smooth scroll to opened item
    if (!isOpen) {
      setTimeout(() => {
        question.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start',
          inline: 'nearest'
        });
      }, 300);
    }
  }

  setupScrollspy() {
    const navLinks = document.querySelectorAll('[data-target]');
    const faqItems = document.querySelectorAll('.faq-item');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const targetId = entry.target.id;
        const links = document.querySelectorAll(`[data-target="${targetId}"]`);
        
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          // Remove active class from all links
          navLinks.forEach(link => link.classList.remove('active'));
          // Add active class to current links
          links.forEach(link => link.classList.add('active'));
        }
      });
    }, { 
      threshold: 0.6,
      rootMargin: '-20% 0px -60% 0px'
    });

    faqItems.forEach(item => observer.observe(item));
  }

  setupFeedback() {
    const feedbackButtons = document.querySelectorAll('[data-feedback]');
    
    feedbackButtons.forEach(button => {
      button.addEventListener('click', () => {
        const feedback = button.dataset.feedback;
        const faqId = button.dataset.faq;
        const key = `faq_${faqId}_feedback`;
        
        // Store feedback in localStorage
        localStorage.setItem(key, feedback);
        
        // Visual feedback
        button.style.transform = 'scale(1.3)';
        button.style.opacity = '1';
        
        setTimeout(() => {
          button.style.transform = 'scale(1)';
        }, 200);
        
        // Update button styles
        const container = button.closest('.help-section');
        const buttons = container.querySelectorAll('[data-feedback]');
        buttons.forEach(btn => {
          btn.classList.remove('helpful', 'not-helpful');
        });
        
        if (feedback === 'yes') {
          button.classList.add('helpful');
        } else {
          button.classList.add('not-helpful');
        }
      });
    });
    
    // Load stored feedback
    feedbackButtons.forEach(button => {
      const faqId = button.dataset.faq;
      const key = `faq_${faqId}_feedback`;
      const storedFeedback = localStorage.getItem(key);
      
      if (storedFeedback === button.dataset.feedback) {
        if (storedFeedback === 'yes') {
          button.classList.add('helpful');
        } else {
          button.classList.add('not-helpful');
        }
      }
    });
  }

  addKeyboardSupport() {
    const questions = document.querySelectorAll('.faq-question');
    
    questions.forEach(question => {
      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleFAQ(question);
        }
      });
    });
  }
}

// Initialize FAQ system when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const faqContainer = document.getElementById('lnc-faq');
  if (faqContainer) {
    new PremiumFAQ();
  }
});

// Performance optimization
if ('IntersectionObserver' in window) {
  const lazyElements = document.querySelectorAll('.faq-item');
  const lazyObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.willChange = 'transform, opacity';
        setTimeout(() => {
          entry.target.style.willChange = 'auto';
        }, 1000);
        lazyObserver.unobserve(entry.target);
      }
    });
  });

  lazyElements.forEach(el => lazyObserver.observe(el));
}
